const motStatusTypes = {
  pass: 'PASSED',
  failure: 'FAILED',
};

export default motStatusTypes;
